define(function(require,exports,module){
    var priceModel = require("../../model/priceModel/priceModel");

    var price = {
        skuArry: [],
        pageNum: 40,
        init: function() {
            var self = this;
            if ($("#priceQuerySwitch").val() != "OFF") {
                self.skuArry = [];
                self.getPrice();
            }
        },
        getPrice: function() {
            var self = this;

            var skuList = "";

            //所有的skuid
            $("[skuid]").each(function() {
                if($(this).attr("hasPrice") !== "1") {
                    if($(this).attr("skuid").indexOf("J_") < 0) {
                        skuList = skuList + "," + "J_" + $(this).attr("skuid");
                    } else {
                        skuList = skuList + "," + $(this).attr("skuid");
                    }
                }
            });

            skuList = skuList.substring(1, skuList.length);
            skuList = skuList.split(",");

            var num = Math.ceil(skuList.length / self.pageNum);

            for (var i = 1; i <= num; i++) {
                var skuids = "";
                for (var j = (i - 1) * self.pageNum; j < i * self.pageNum; j++) {
                    if (typeof(skuList[j]) != "undefined") {
                        skuids = skuids + "," + skuList[j];
                    } else {
                        continue;
                    }
                }
                skuids = skuids.substring(1, skuids.length);

                if (skuids != "") {
                    self.skuArry.push(skuids);
                }
            }

            if (self.skuArry.length == 0) {
                return false;
            }
            for (var i = 0; i < self.skuArry.length; i++) {
                self.ajaxPrice(self.skuArry[i]);
            }
        },
        ajaxPrice: function(skuArry) {
            var self = this;
            var arg = {"skuids": skuArry,"source": "jd_worldwide"};

            priceModel.ajaxGetPrice(arg, function(data) {

                $.each(data, function() {
                    var newPrice = priceModel.formatPrice(this.p);
                    var oldPrice = priceModel.formatPrice(this.m);

                    var thisObj = $("[skuid='" + this.id + "']");

                    //PC版频道页没有获取到价格的时候，不做处理，所以直接返回
                    if (newPrice == "-1" || oldPrice == "-1") {
                        thisObj.find(".discount").remove();
                        return true;
                    }

                    thisObj.find(".price span").html("<b>&yen;</b>" + newPrice);
                    thisObj.find(".price del").html("&yen;" + oldPrice);
                    thisObj.find(".price .consult").html("参考价&yen;<em>" + oldPrice + "</em>");

                    thisObj.attr("hasPrice","1");

                    var discount = priceModel.getDiscount(newPrice, oldPrice);

                    if(discount == "") {
                        thisObj.find(".discount").remove();
                    } else {
                        if(thisObj.parents(".w").parent().hasClass("special-sale")) {
                            thisObj.find(".discount").html('<div class="bg"><div class="poi"><span class="num">'+ discount +'</span><span>折</span></div></div>');
                        } else {
                            thisObj.find(".discount").html(discount + "折");
                        }
                    }
                });
            });
        }
    };
    exports.fn = price;
});



// WEBPACK FOOTER //
// ./src/js/unit/newprice/newprice.js